import { useQuery } from '@tanstack/react-query';
import { useDataProvider } from '@/data/provider';
import { queryKeys } from '@/lib/query-keys';

export function useCompanyReports(companyId: string | undefined) {
  const { reports } = useDataProvider();
  return useQuery({
    queryKey: companyId ? queryKeys.reports.byCompany(companyId) : queryKeys.reports.all,
    queryFn: async () => {
      if (!companyId) return [];
      return reports.list(companyId);
    },
    enabled: Boolean(companyId),
  });
}

export function useSiteReports(siteId: string | undefined) {
  const { reports } = useDataProvider();
  return useQuery({
    queryKey: siteId ? queryKeys.reports.bySite(siteId) : queryKeys.reports.all,
    queryFn: async () => {
      if (!siteId) return [];
      return reports.listBySite(siteId);
    },
    enabled: Boolean(siteId),
  });
}

export function useAllReports() {
  const { reports } = useDataProvider();
  return useQuery({
    queryKey: queryKeys.reports.lists(),
    queryFn: () => reports.list(),
  });
}

export function useReport(reportId: string | undefined) {
  const { reports } = useDataProvider();
  return useQuery({
    queryKey: reportId ? queryKeys.reports.detail(reportId) : queryKeys.reports.all,
    queryFn: async () => {
      if (!reportId) return null;
      return reports.get(reportId);
    },
    enabled: Boolean(reportId),
  });
}

export function useReportLock(reportId: string | undefined) {
  const { reports } = useDataProvider();
  return useQuery({
    queryKey: reportId ? queryKeys.reports.lock(reportId) : queryKeys.reports.all,
    queryFn: async () => {
      if (!reportId) return null;
      return reports.getLockState(reportId);
    },
    enabled: Boolean(reportId),
  });
}
